import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NConfigProvider, NMessageProvider, NGrid, NGridItem } from 'naive-ui'
import HeaderItems from '@/components/HeaderItems.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const themeOverrides = {
  common: {
    primaryColor: '#71c8cb',
  },
  Input: {
    borderHover: '#71c8cb',
    borderFocus: '#71c8cb',
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), { "theme-overrides": themeOverrides }, {
    default: _withCtx(() => [
      _createVNode(_unref(NMessageProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NGrid), {
            cols: 1,
            class: "content"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NGridItem), null, {
                default: _withCtx(() => [
                  _createVNode(HeaderItems)
                ]),
                _: 1
              }),
              _createVNode(_unref(NGridItem), null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})